export enum DashboardElementType {
  Heading = 1,
  Subheading,
  Grid,
  Analytic,
  MyActions,
  ListView,
}

export const ContainerableElements = [
  DashboardElementType.Grid
]

export const UncontainableElements = [
  DashboardElementType.Grid,
  DashboardElementType.MyActions,
  DashboardElementType.ListView,
]